module.exports = __webpack_public_path__ + "static/img/role-active.eb1aeef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/role-active.png
// module id = CdVW
// module chunks = 26